import React, { useContext, useEffect, useState } from 'react'
import { DataContext } from '../../context/DataContext'

import AddressUserData from './AddressUserData'
import ManualDirection from './ManualDirection'
import { useAbandonedCart } from '../../hook/useAbandonedCart'
import { MAPBOX_STATIC_MAP_URL } from '../../constants/url'

function AddressTypeInputSelector () {
  const [isEditing, setIsEditing] = useState(false)
  const [selectedPointData, setSelectedPointData] = useState(undefined)
  const {
    steps,
    setAddressInfo,
    setSteps,
    addressInfo,
    setSelectedServiceType,
    setCartData,
    setSelectedShippingMethod,
    userInfo,
    isUserValidated,
    abandonedCartData,
    abandonedCart,
    companyInfo
  } = useContext(DataContext)

  const { upsertAbandonedCart } = useAbandonedCart()

  const handleAddressInformation = ({
    serviceType,
    price,
    courier,
    serviceName
  }) => {
    setAddressInfo(prevState => {
      return {
        ...prevState,
        price,
        courier,
        serviceType,
        serviceName
      }
    })
    const updatedSteps = [...steps]
    updatedSteps[0].completed = true
    updatedSteps[1].disabled = false
    updatedSteps[1].subSteps[0].completed = true
    setSteps(updatedSteps)
  }

  const mapDesktopUrl = selectedPointData && selectedPointData.center
    ? `${MAPBOX_STATIC_MAP_URL}${selectedPointData.center[0]},${selectedPointData.center[1]},14.1,0,0/440x200?access_token=${companyInfo.mapboxToken}`
    : null

  const setGiftCardProduct = (arrayAddress, aditionalInfo) => {
    updateAddressInfo(arrayAddress, aditionalInfo)
    setFreeServiceType()
    setShippingMethodToUnnecessary()
    markCartAsFreeShipping()
    updateStepsForGiftCard()
  }

  const updateAddressInfo = (arrayAddress, aditionalInfo) => {
    setAddressInfo(prevState => ({
      ...prevState,
      userAddress: arrayAddress[0],
      district: arrayAddress[1],
      region: arrayAddress[2],
      aditionalInfo,
      deliveryType: 'No aplica despacho',
      requireShipping: false,
      price: 0
    }))
  }

  const setFreeServiceType = () => {
    setSelectedServiceType(prevState => ({
      ...prevState,
      price: 0
    }))
  }

  const setShippingMethodToUnnecessary = () => {
    setSelectedShippingMethod('unnecessary')
  }

  const markCartAsFreeShipping = () => {
    setCartData(prevState => ({
      ...prevState,
      isFreeShipping: true
    }))
  }

  const updateStepsForGiftCard = () => {
    const updatedSteps = [...steps]
    updatedSteps[0].completed = true
    updatedSteps[1].disabled = false
    updatedSteps[1].subSteps[0].completed = true
    updatedSteps[1].subSteps[1].completed = true
    setSteps(updatedSteps)
  }

  useEffect(() => {
    const updatedAddressInfo = { ...addressInfo, manualDelivery: (userInfo.isRegistered && !isUserValidated) ? false : !selectedPointData }
    setAddressInfo(updatedAddressInfo)
  }, [selectedPointData])

  useEffect(() => {
    if (steps[1].subSteps[1].completed && !abandonedCart) {
      upsertAbandonedCart(abandonedCartData)
    }
  }, [abandonedCartData, steps[1].subSteps[1].completed])

  return (
    <div className='md:h-full bg-slate-100 flex flex-col grow md:w-[537px]'>
      <div>
        <p className="text-center text-gray-800 text-sm pt-5 font-sm">
          Ingresa una dirección para recibir tu compra
        </p>
      </div>
      {!isEditing
        ? (
            <AddressUserData
              setter={setIsEditing}
              selectedPointData={selectedPointData}
              mapUrl={mapDesktopUrl}
              setSelectedPointData={setSelectedPointData}
              handleAddressInformation={handleAddressInformation}
              setGiftCardProduct={setGiftCardProduct}
            />
          )
        : (
            <ManualDirection
              setter={setIsEditing}
              selectedPointData={selectedPointData}
              mapUrl={mapDesktopUrl}
              handleAddressInformation={handleAddressInformation}
              setGiftCardProduct={setGiftCardProduct}
            />
          )
      }
    </div>
  )
}

export default AddressTypeInputSelector
